import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { withRouter, Link } from "react-router-dom";
import { useMutation } from "react-apollo-hooks";
import { GRU_SAVING_INFO_WRITE_QUERY } from "./Queries";
import { useForm } from "react-hook-form";
import { Panel, PanelHeader, PanelBody } from "../../../Components/Panel/Panel";
import { toast } from "react-toastify";
import { currencyName } from "../../../Components/User/UserNames";

import WriteStore from "./WriteStore";

export default withRouter(({ history, location }) => {
  const [gruSavingInfoWriteMutation] = useMutation(
    GRU_SAVING_INFO_WRITE_QUERY
  );
  const { register, handleSubmit, errors, watch } = useForm({
    defaultValues: {
      commonStatus: "C",
      isLocationCheck: "false",
      amount: "",
    },
  });
  const [store, setStore] = useState("");

  const amount = watch("amount");
  const isLocationCheck = watch("isLocationCheck");

  // 명칭은 서버에서 자동 생성되므로 화면에서는 미리보기만 보여준다.
  const namePreview =
    store && amount
      ? `${store.label} ${Number(amount).toLocaleString()}${currencyName(
          "GRU"
        )} 적립`
      : "";

  const onSubmit = async (data) => {
    if (store === "") {
      return toast.error("가맹점을 선택해주세요.");
    }
    if (!Number(data.amount) || Number(data.amount) <= 0) {
      return toast.error("적립 금액을 확인해주세요.");
    }
    if (data.isLocationCheck === "true" && !store.hasLocation) {
      return toast.error(
        "선택한 가맹점에 좌표가 없어 위치 검증을 사용할 수 없습니다."
      );
    }

    try {
      const {
        data: { AdminGruSavingInfoWrite },
      } = await gruSavingInfoWriteMutation({
        variables: {
          store: store.value,
          amount: Number(data.amount),
          currency: "GRU",
          isLocationCheck: data.isLocationCheck === "true",
          commonStatus: data.commonStatus,
        },
      });
      if (AdminGruSavingInfoWrite) {
        toast.success("처리 되었습니다.");
        history.push(`/gruSavings${location.search}`);
      }
    } catch (e) {
      console.log(e);
      let errorMessage = "에러가 발생했습니다. 다시 시도해 주세요.";
      if (e.graphQLErrors && e.graphQLErrors.length > 0) {
        errorMessage = e.graphQLErrors.map((err) => err.message).join("\n");
      }
      toast.error(errorMessage);
    }
  };

  return (
    <>
      <Helmet>
        <title>적립정보 등록 | 한밭페이</title>
      </Helmet>
      <form className="margin-bottom-0" onSubmit={handleSubmit(onSubmit)}>
        <div>
          <ol className="breadcrumb float-xl-right">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Home</Link>
            </li>
            <li className="breadcrumb-item active">
              <Link to={`/gruSavings${location.search}`}>NFC 적립</Link>
            </li>
            <li className="breadcrumb-item active">등록</li>
          </ol>
          <h1 className="page-header">NFC 적립</h1>

          <div className="row m-b-15">
            <div className="col-xs-6 text-left">
              <div className="btn-group">
                <Link
                  to={`/gruSavings${location.search}`}
                  className="btn btn-white"
                >
                  목록
                </Link>
              </div>
            </div>
            <div className="col-xs-6 text-right">
              <div className="btn-group">
                <button type="submit" className="btn btn-white text-success">
                  <i className="fa fa-check m-r-5"></i>등록
                </button>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12">
              <Panel>
                <PanelHeader noButton={true}>적립정보</PanelHeader>
                <PanelBody>
                  <div className="form-group row">
                    <label className="col-form-label col-md-3">상태</label>
                    <div className="col-md-9">
                      <div className="radio radio-css radio-inline">
                        <input
                          type="radio"
                          id="commonStatusC"
                          name="commonStatus"
                          className="form-control m-b-5"
                          value="C"
                          ref={register({
                            required: "상태를 선택해주세요.",
                          })}
                        />
                        <label htmlFor="commonStatusC">사용</label>
                      </div>
                      <div className="radio radio-css radio-inline">
                        <input
                          type="radio"
                          id="commonStatusS"
                          name="commonStatus"
                          className="form-control m-b-5"
                          value="S"
                          ref={register({
                            required: "상태를 선택해주세요.",
                          })}
                        />
                        <label htmlFor="commonStatusS">중지</label>
                      </div>
                      {errors.commonStatus && (
                        <div>
                          <span>{errors.commonStatus.message}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-form-label col-md-3">
                      적립 가맹점
                    </label>
                    <div className="col-md-9">
                      <WriteStore store={store} setStore={setStore} />
                      {store && !store.hasLocation && (
                        <div className="text-muted f-s-12 m-t-5">
                          이 가맹점은 좌표가 등록되어 있지 않아 위치 검증을
                          사용할 수 없습니다.
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-form-label col-md-3">
                      적립 금액({currencyName("GRU")})
                    </label>
                    <div className="col-md-9">
                      <input
                        type="number"
                        name="amount"
                        className="form-control m-b-5"
                        style={{ maxWidth: 240 }}
                        placeholder="적립 금액 입력"
                        ref={register({
                          required: "적립 금액을 입력해주세요.",
                        })}
                      />
                      {errors.amount && <span>{errors.amount.message}</span>}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-form-label col-md-3">위치 검증</label>
                    <div className="col-md-9">
                      <div className="radio radio-css radio-inline">
                        <input
                          type="radio"
                          id="isLocationCheckTrue"
                          name="isLocationCheck"
                          className="form-control m-b-5"
                          value="true"
                          ref={register()}
                        />
                        <label htmlFor="isLocationCheckTrue">사용</label>
                      </div>
                      <div className="radio radio-css radio-inline">
                        <input
                          type="radio"
                          id="isLocationCheckFalse"
                          name="isLocationCheck"
                          className="form-control m-b-5"
                          value="false"
                          ref={register()}
                        />
                        <label htmlFor="isLocationCheckFalse">미사용</label>
                      </div>
                      <div className="text-muted f-s-12 m-t-5">
                        사용 시 가맹점 반경 150m 안에서만 적립할 수 있습니다.
                        가맹점 좌표가 등록되어 있어야 합니다.
                      </div>
                      {isLocationCheck === "true" &&
                        store &&
                        !store.hasLocation && (
                          <div className="text-danger f-s-12 m-t-5">
                            선택한 가맹점에 좌표가 없습니다.
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-form-label col-md-3">
                      명칭(자동 생성)
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control m-b-5"
                        value={namePreview}
                        placeholder="가맹점과 금액을 입력하면 자동으로 만들어집니다."
                        readOnly
                      />
                      <div className="text-muted f-s-12">
                        명칭은 등록 시 서버에서 생성됩니다.
                      </div>
                    </div>
                  </div>
                </PanelBody>
              </Panel>
            </div>
          </div>
        </div>
      </form>
    </>
  );
});
